import DrawPolygonWStep from "./DrawPolygonWStep";

export default DrawPolygonWStep;
